import React from "react";

const WoType = ({ serviceType }) => {
  return (
    <div
      className="inline-flex items-center justify-center px-[10px] py-[2px] rounded-[6px] font-OpenSansSemiBold font-[600] text-[14px] leading-5 tracking-[0.14px] text-center break-words"
      style={{ backgroundColor: "#EAF3FF", color: "#0058E5" }}
    >
      {serviceType?.serviceType}
    </div>
  );
};

// const WoType = ({ serviceType }) => {
//   return <div className="inline-flex items-center justify-center px-[10px] py-[2px] rounded-[6px] font-OpenSansSemiBold font-[600] text-[14px] leading-5 tracking-[0.14px] text-center break-words" style={{ backgroundColor: serviceType?.backgroundColor ?? "#EAF3FF", color: serviceType?.textColor ?? "#0058E5" }}>
//     {serviceType?.serviceType}
//   </div>
// };

export default WoType;
